<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-expansion-panel expand :readonly="readonly" :class="{ 'expand-header-hidden': readonly }" v-model="open_state">
        <v-expansion-panel-content v-for="(membro, index) in membros" :key="index">
            <!--suppress HtmlUnknownBooleanAttribute -->
            <template v-slot:header>
                <v-layout v-if="membro.editando">
                    <v-flex style="margin-bottom: -15px">
                        <!-- @click.native.stop serve pro clique no campo não dar trigger no expansion-panel -->
                        <autocomplete placeholder="Selecione um usuário"
                                      url="/admin/hierarquias/autocomplete"
                                      hierarquia=true
                                      @change="usuario => usuarioSelecionado(membro.hierarquia.id_usuario, usuario, membro.id_hierarquia, index)"
                                      :params="{ ...autocomplete_params, permite_usuario_fantasma }"
                                      :cache-items="false"
                                      item-text="nome"
                                      item-value="id_usuario"
                                      class="mt-2 mb-2"
                                      :min-length="0"
                                      return-object
                                      :hide-selected="false"
                                      @click.native.stop>
                            <v-icon color="primary" slot="append">ol-search</v-icon>
                        </autocomplete>
                    </v-flex>
                    <v-flex style="margin-top: 20px" ml-2>
                        <v-icon color="primary" @click.stop="cancelarEdicao(index, membro.id_hierarquia, membro.hierarquia.id_usuario)">ol-close</v-icon>
                    </v-flex>
                </v-layout>

                <div v-else class="titulo-membro">
                    <v-btn flat icon color="primary" @click.stop="excluir(index, membro.id_hierarquia, membro.hierarquia.id_usuario)">
                        <v-icon>ol-delete</v-icon>
                    </v-btn>
                    <v-btn flat icon color="primary" @click.stop="$emit('editar', { ...superiores, [index_name]: index })">
                        <v-icon>ol-edit</v-icon>
                    </v-btn>
                    <span class="expand-header dark--text">{{ membro.hierarquia.usuario.nome || 'Vazio' }}</span>
                </div>
            </template>

            <div class="expand-body">
                <slot name="membro" :membro="{ ...membro, index }" />
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import { alert } from '@/plugins/helpers'

export default {
  name: 'HierarquiaMembro',
  props: {
    membros: {
      type: Array,
      required: true
    },
    nivel: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autocomplete_params: {
      type: Object,
      required: true
    },
    id_usuario_superior: {
      type: Number,
      required: true
    },
    // UUID gerado em tempo de execução no backend
    id_usuario_superior_fantasma: {
      type: String,
      default: null
    },
    permite_usuario_fantasma: {
      type: Boolean,
      default: false
    },
    superior_fantasma: {
      type: Boolean,
      default: false
    },
    diretor_index: Number,
    regional_index: Number,
    gerente_index: Number,
    supervisor_index: Number
  },
  computed: {
    // Aqui é retornado todos os índices dos superiores do membro atual, para na edição/exclusão ficar fácil
    // a identificação desse membro no objeto com a hierarquia
    superiores () {
      return {
        diretor_index: this.diretor_index,
        regional_index: this.regional_index,
        gerente_index: this.gerente_index,
        supervisor_index: this.supervisor_index
      }
    },
    // Controla quais membros estão expandidos e quais collapsados
    open_state: {
      get () {
        return this.membros.map(membro => !!membro.opened)
      },
      set (value) {
        const membros = this.membros
        for (const i in value) {
          // noinspection JSUnfilteredForInLoop
          membros[i].opened = value[i]
        }
        this.$emit('updateMembro',
          {
            indices: { ...this.superiores },
            membro: { [this.nivel_plural]: membros }
          })
      }
    },
    // Retorna o nome da chave que define o índice do membro com base no nível da hierarquia,
    // Ex.: se nível é vendedor retorna vendedor_index
    index_name () {
      return `${this.nivel}_index`
    },
    nivel_plural () {
      const plurais = {
        diretor: 'diretores',
        regional: 'regionais',
        gerente: 'gerentes',
        supervisor: 'supervisor', // Vem assim do WS mesmo, no singular
        vendedor: 'vendedores'
      }
      return plurais[this.nivel]
    }
  },
  methods: {
    usuarioSelecionado (id_usuario_antigo, usuario, id_hierarquia, index) {
      this.$emit('usuarioSelecionado',
        {
          usuario,
          id_hierarquia,
          nivel: this.nivel,
          id_usuario_superior: this.id_usuario_superior,
          id_usuario_antigo,
          superior_fantasma: this.superior_fantasma,
          id_usuario_superior_fantasma: this.id_usuario_superior_fantasma,
          membro: { ...this.superiores, [this.index_name]: index }
        }
      )
    },
    cancelarEdicao (membro_index, id_hierarquia, id_usuario) {
      if (id_hierarquia) {
        this.$emit('cancelarEdicao', { ...this.superiores, [this.index_name]: membro_index })
      } else {
        this.emitirEventoExclusao(membro_index, id_hierarquia, id_usuario)
      }
    },
    excluir (membro_index, id_hierarquia, id_usuario) {
      if (this.nivel !== 'vendedor') {
        alert({
          text: `Tem certeza que deseja remover este ${this.nivel}?\nTodos os subordinados serão removidos.`,
          buttons: {
            'Cancelar': () => true,
            'Excluir': () => this.emitirEventoExclusao(membro_index, id_hierarquia, id_usuario)
          }
        })
      } else {
        this.emitirEventoExclusao(membro_index, id_hierarquia, id_usuario)
      }
    },
    emitirEventoExclusao (membro_index, id_hierarquia, id_usuario) {
      this.$emit('excluir', {
        indices: { ...this.superiores, [this.index_name]: membro_index },
        id_hierarquia,
        nivel: this.nivel,
        id_usuario
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .expand-body {
        margin-left: 12px;
        padding-left: 20px;
        border-left: solid 2px var(--grey);
        .focused {
            border-color: var(--primary)
        }
    }
    .expand-header {
        font-weight: bold;
    }
</style>

<style lang="stylus">
    .v-expansion-panel {
        box-shadow: none;
        .v-expansion-panel__header {
            padding: 0;
            min-height: 0;
            flex-direction: row-reverse;
            justify-content flex-end;
            .titulo-membro {
                display: flex;
                flex-direction: row-reverse;
                justify-content flex-end;
                align-items: center;

                &> * {
                    flex: none;
                }
                &> .v-btn {
                    margin: 0;
                }
                &> span {
                    margin-right: 10px;
                }
            }
        }
    }
    .expand-header-hidden > li > .v-expansion-panel__header .v-expansion-panel__header__icon {
        display: none;
    }
    .theme--light.v-expansion-panel .v-expansion-panel__container {
        border-top: none;
    }
    .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
        transform: rotate(-90deg);
    }
    .v-expansion-panel__container--active>.v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
        transform: rotate(0deg);
    }
</style>
